export { default as DocumentPlusOutlineIcon } from './DocumentPlusOutlineIcon';
